import { configureStore } from "@reduxjs/toolkit";
import postReducer from "./postSlice";
import settingsReducer from "./settingsSlice";
import projectReducer from "./projectSlice";

const store = configureStore({
  reducer: {
    posts: postReducer,
    settings: settingsReducer,
    projects: projectReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
